import {
	generateEffectiveSalary,
	getCCEffectiveSalaryPayment,
} from '@/API/repositories/reports';
import { LAST_YEAR_MONTHS } from '@/common/constants/lastYearMonths';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMemo, useState } from 'react';
import { updateState } from '../helpers/updateState';
import { sortAlphabetically } from '@/common/functions/sortAlphabetically';

const useCCPayment = () => {
	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const {
		commonData: { users },
		COUNTRIES,
	} = useCommonDataContext();
	const marketsOptions = useMemo(() => {
		return sortAlphabetically(COUNTRIES ?? [], 'label');
	}, [COUNTRIES]);

	const isLoading =
		hasUnfilledRequest(getCCEffectiveSalaryPayment) ||
		hasUnfilledRequest(generateEffectiveSalary);
	const [selectedMonth, setSelectedMonth] = useState(LAST_YEAR_MONTHS[1]);
	const [consultantsFilterOption, setConsultantFilterOption] = useState();
	const [selectedConsultant, setSelectedConsultant] = useState();
	const [selectedMarkets, setSelectedMarkets] = useState();
	const [paymentData, setPaymentData] = useState();
	const [forexRates, setForexRates] = useState();

	const handleSelectMarkets = (markets) => {
		setSelectedMarkets(markets);
		setSelectedConsultant(() => {
			const marketsShorts = markets.map((m) => m.value);
			const consultants = consultantsFilterOption.filter((consultantOption) =>
				marketsShorts.includes(consultantOption.value.marketShort),
			);
			return consultants;
		});
	};

	const hanldeSearch = async () => {
		const payload = {};
		payload.month = selectedMonth.value;

		const response = await makeRequest(
			getCCEffectiveSalaryPayment.bind(null, selectedMonth.value.toISOString()),
		);

		if (response.data.result.length > 0) {
			const usersFromReport = response.data.result.map((result) => result._id);

			const result = users.filter((user) => usersFromReport.includes(user._id));
			const usersOptions = result.map((user) => {
				return {
					label: user.username,
					value: {
						marketShort:
							user.contract_type?.split('_')[0]?.toLowerCase() ?? null,
						_id: user._id,
					},
				};
			});

			setConsultantFilterOption(() => usersOptions);
			setSelectedConsultant(() => usersOptions);
			setPaymentData(() => response.data.result);
			setForexRates(() => response.data.forexRates);
			return;
		}

		setPaymentData(() => []);
		setForexRates(() => []);
	};

	const reloadData = async (paymentId) => {
		const result = await makeRequest(
			generateEffectiveSalary.bind(null, {
				paymentId,
			}),
		);
		setPaymentData((prevState) => updateState(prevState, result.data));
	};

	return {
		isLoading,
		setSelectedMonth,
		selectedMonth,
		hanldeSearch,
		paymentData,
		consultantsFilterOption,
		setSelectedConsultant,
		selectedConsultant,
		forexRates,
		reloadData,
		handleSelectMarkets,
		selectedMarkets,
		setSelectedMarkets,
		marketsOptions,
	};
};

export default useCCPayment;
